export default {
  pagination: {},
  recommendations: [],
  recommendationProfile: {},
  recommendationTotal: 0,
  comissions: []
};
